import React from 'react';

import { Colors } from '../color/Colors';

export const AppSecLogo = ({style}: {style?: Record<string, any>}) => {
  return (
    <div>
      <img style={{ ...style, filter: Colors.logoFilter }} src='/pictures/AppSecLogo.svg' alt="AppSec Logo" />
    </div>
  );
};